import { RadioGroup } from '@platform/components';
import { CompletedOutcomes } from '.';

type OutcomeSelectionContentProps = {
  completedOutcome?: CompletedOutcomes;
  setCompletedOutcome: (outcome: CompletedOutcomes) => void;
  otherPartyName: string;
};
export const OutcomeSelectionContent = (props: OutcomeSelectionContentProps) => {
  const { setCompletedOutcome, otherPartyName } = { ...props };

  const validateRadio = (value: string | number | null): string | undefined => {
    if (!value) {
      return 'Select one option to continue';
    }
  };

  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      <div className='text-center text-xl'>Great! Do you want to match with {otherPartyName}?</div>
      {/* TODO: This did have isRequired, which is a reasonable expectation given that this selection is required to press the submit CTA. However, the current iteration of our forms logic & the radio group makes the error validation text appear by default when set true */}
      <div className='mt-4 w-full'>
        <RadioGroup
          name='outcome-selection'
          aria-label='outcome-reason'
          isRequired
          items={[
            {
              value: CompletedOutcomes.Accepted,
              title: "Yes, it's the right fit",
            },
            {
              value: CompletedOutcomes.Declined,
              title: "No, it's not a good fit",
            },
            {
              value: CompletedOutcomes.Need_Help,
              title: 'I need help deciding',
            },
          ]}
          onChange={(value) => {
            setCompletedOutcome(value as CompletedOutcomes);
          }}
          validate={validateRadio}
        />
      </div>
    </div>
  );
};
